export const ACCOUNT = 'account/' as const
export const ACCOUNT_TYPES = `${ACCOUNT}types` as const
export const ACCOUNT_PASSWORD_RESET = `${ACCOUNT}password/reset` as const
export const ACCOUNT_REQUIRED_ACTION = `${ACCOUNT}required_action/` as const
export const ACCOUNT_PROFILE_PIC = `${ACCOUNT}profile_pic/` as const
export const ACCOUNT_PROFILE_UPDATE = `${ACCOUNT}profile/` as const
